import { Route, Routes } from "react-router-dom";
import {
	GetClinics,
	GetConsults,
	GetDoctors,
	MsalListener,
	ProtectedRoute
} from "./components/App";
import { Layout, LoginButton } from "./components/Layout";
import {
	AuditLogs,
	OurMedicalBlogs,
	OurMedicalBlogEdit,
	OurSageBlogs,
	OurSageBlogEdit,
	OursageLogs,
	ClinicSettings,
	NoAccess,
	DoctorEdit,
	TelehealthDoctors,
	TelehealthCentres,
	TelehealthQueue,
	DoctorAdmin,
	CentreOperations,
	HolidayAdmin,
	TelehealthAvailability,
	PatientSearch,
	BannedPatientMessageEdit,
	AppVersions
} from "./pages";
import { ROUTES, ROUTE_ROLES } from "./constants";
import { SignalREventHandler } from "./eventHandlers";
import {
	AuthenticatedTemplate,
	UnauthenticatedTemplate
} from "@azure/msal-react";

export const App = () => {
	return (
		<>
			<MsalListener />
			<AuthenticatedTemplate>
				<GetClinics />
				<GetConsults />
				<GetDoctors />
				<SignalREventHandler />
				<Layout>
					<Routes>
						<Route path="/" element={null} />
						<Route
							path={ROUTES.ourmedicalBlogs}
							element={
								<ProtectedRoute
									element={<OurMedicalBlogs />}
									allowedRoles={ROUTE_ROLES[ROUTES.ourmedicalBlogs]}
									path={ROUTES.ourmedicalBlogs}
								/>
							}
						/>
						<Route
							path={ROUTES.ourmedicalBlogsEdit}
							element={
								<ProtectedRoute
									element={<OurMedicalBlogEdit />}
									allowedRoles={ROUTE_ROLES[ROUTES.ourmedicalBlogsEdit]}
									path={ROUTES.ourmedicalBlogsEdit}
								/>
							}
						/>
						<Route
							path={ROUTES.oursageBlogs}
							element={
								<ProtectedRoute
									element={<OurSageBlogs />}
									allowedRoles={ROUTE_ROLES[ROUTES.oursageBlogs]}
									path={ROUTES.oursageBlogs}
								/>
							}
						/>
						<Route
							path={ROUTES.oursageBlogEdit}
							element={
								<ProtectedRoute
									element={<OurSageBlogEdit />}
									allowedRoles={ROUTE_ROLES[ROUTES.oursageBlogEdit]}
									path={ROUTES.oursageBlogEdit}
								/>
							}
						/>
						<Route
							path={ROUTES.oursageLogs}
							element={
								<ProtectedRoute
									element={<OursageLogs />}
									allowedRoles={ROUTE_ROLES[ROUTES.oursageLogs]}
									path={ROUTES.oursageLogs}
								/>
							}
						/>
						<Route
							path={ROUTES.clinicSettings}
							element={
								<ProtectedRoute
									element={<ClinicSettings />}
									allowedRoles={ROUTE_ROLES[ROUTES.clinicSettings]}
									path={ROUTES.clinicSettings}
								/>
							}
						/>
						<Route
							path={ROUTES.appVersions}
							element={
								<ProtectedRoute
									element={<AppVersions />}
									allowedRoles={ROUTE_ROLES[ROUTES.appVersions]}
									path={ROUTES.appVersions}
								/>
							}
						/>
						<Route
							path={ROUTES.telehealthCentres}
							element={
								<ProtectedRoute
									element={<TelehealthCentres />}
									allowedRoles={ROUTE_ROLES[ROUTES.telehealthCentres]}
									path={ROUTES.telehealthCentres}
								/>
							}
						/>
						<Route
							path={ROUTES.centreOperations}
							element={
								<ProtectedRoute
									element={<CentreOperations />}
									allowedRoles={ROUTE_ROLES[ROUTES.centreOperations]}
									path={ROUTES.centreOperations}
								/>
							}
						/>
						<Route
							path={ROUTES.doctorAdmin}
							element={
								<ProtectedRoute
									element={<DoctorAdmin />}
									allowedRoles={ROUTE_ROLES[ROUTES.doctorAdmin]}
									path={ROUTES.doctorAdmin}
								/>
							}
						/>
						{/* <Route
							path={ROUTES.telehealthSchedule}
							element={
								<ProtectedRoute
									element={<TelehealthSchedules />}
									allowedRoles={ROUTE_ROLES[ROUTES.telehealthSchedule]}
									path={ROUTES.telehealthSchedule}
								/>
							}
						/> */}
						{/* <Route
							path={ROUTES.telehealthScheduleEdit}
							element={
								<ProtectedRoute
									element={<TelehealthScheduleEdit />}
									allowedRoles={ROUTE_ROLES[ROUTES.telehealthScheduleEdit]}
									path={ROUTES.telehealthScheduleEdit}
								/>
							}
						/> */}
						<Route
							path={ROUTES.doctorEdit}
							element={
								<ProtectedRoute
									element={<DoctorEdit />}
									allowedRoles={ROUTE_ROLES[ROUTES.doctorEdit]}
									path={ROUTES.doctorEdit}
								/>
							}
						/>
						<Route
							path={ROUTES.telehealthQueue}
							element={
								<ProtectedRoute
									element={<TelehealthQueue />}
									allowedRoles={ROUTE_ROLES[ROUTES.telehealthQueue]}
									path={ROUTES.telehealthQueue}
								/>
							}
						/>
						<Route
							path={ROUTES.telehealthDoctors}
							element={
								<ProtectedRoute
									element={<TelehealthDoctors />}
									allowedRoles={ROUTE_ROLES[ROUTES.telehealthDoctors]}
									path={ROUTES.telehealthDoctors}
								/>
							}
						/>
						<Route
							path={ROUTES.auditLogs}
							element={
								<ProtectedRoute
									element={<AuditLogs />}
									allowedRoles={ROUTE_ROLES[ROUTES.auditLogs]}
									path={ROUTES.auditLogs}
								/>
							}
						/>
						<Route
							path={ROUTES.holidays}
							element={
								<ProtectedRoute
									element={<HolidayAdmin />}
									allowedRoles={ROUTE_ROLES[ROUTES.holidays]}
									path={ROUTES.holidays}
								/>
							}
						/>
						<Route
							path={ROUTES.telehealthSchedules}
							element={
								<ProtectedRoute
									element={<TelehealthAvailability />}
									allowedRoles={ROUTE_ROLES[ROUTES.telehealthSchedules]}
									path={ROUTES.telehealthSchedules}
								/>
							}
						/>
						<Route
							path={ROUTES.patientSearch}
							element={
								<ProtectedRoute
									element={<PatientSearch />}
									allowedRoles={ROUTE_ROLES[ROUTES.patientSearch]}
									path={ROUTES.patientSearch}
								/>
							}
						/>
						<Route
							path={ROUTES.bannedPatientMessage}
							element={
								<ProtectedRoute
									element={<BannedPatientMessageEdit />}
									allowedRoles={ROUTE_ROLES[ROUTES.bannedPatientMessage]}
									path={ROUTES.bannedPatientMessage}
								/>
							}
						/>
						<Route path={ROUTES.noAccess} element={<NoAccess />} />
					</Routes>
				</Layout>
			</AuthenticatedTemplate>
			<UnauthenticatedTemplate>
				<LoginButton />
			</UnauthenticatedTemplate>
		</>
	);
};
